<template>
  <div class="banner-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/07/banner_icon.png"
           alt="">
      banner管理
    </div>
    <el-form ref="form"
             :model="form"
             class="bannerlist_search"
             :inline="true">
      <el-form-item label="所属应用">
        <el-select v-model="form.name"
                   size="small">
          <el-option label="物流端"
                     value="0"></el-option>
          <el-option label="货主端"
                     value="1"></el-option>
          <el-option label="智能硬件"
                     value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   size="small"
                   @click="handleSelectApp(form.name)"
                   class="search_btn">查看</el-button>
      </el-form-item>
      <el-form-item class="btn_box">
        <router-link to="banner/addBanner">
          <el-button type="warning"
                     size="small"
                     class="add_btn">添加</el-button>

        </router-link>
      </el-form-item>
    </el-form>
    <div class="banner_table">
      <el-table :data="bannerList.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         fixed
                         label=""
                         align="center"
                         type="index"
                         width="1">
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="所属应用"
                         min-width="130">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.appName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片标题"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div>{{scope.row.title}}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片大小"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div>{{scope.row.size}}M</div>
          </template>
        </el-table-column>
        <el-table-column label="图片格式"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div>{{scope.row.suffix}}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div class="imgUrl"><img :src="scope.row.imgUrl"
                   alt=""></div>
          </template>
        </el-table-column>
        <el-table-column label="发布时间"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div>{{scope.row.creatDateString}}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         min-width="94">
          <template slot-scope="scope">
            <div v-if="scope.row.status==='0'">可用</div>
            <div v-else-if="scope.row.status==='1'">禁用</div>
          </template>
        </el-table-column>

        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item unblocked"
                        effect="dark"
                        content="禁用"
                        placement="top"
                        v-if="scope.row.status === '0'">
              <el-button @click="handleBannerDisbaled(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item unblocked"
                        effect="dark"
                        content="解禁"
                        placement="top"
                        v-else-if="scope.row.status === '1'">
              <el-button @click="handleBannerDisbaled(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{bannerList.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="bannerList.pageSize"
                     layout="prev, pager, next"
                     :total="bannerList.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { bannerList, disableBanner, deleteBanner } from 'apis/index'
import { mapState } from 'vuex'
export default {
  name: 'Container',
  data () {
    return {
      bannerList: [],
      form: {
        name: ''
      },
      pageNum: 1,
      appType: ''

    }
  },
  computed: mapState({
    showAddBank: state => state.banner.show
  }),
  mounted () {
    this.getBannerData()
  },
  methods: {
    getBannerData () { // 获取banner列表
      bannerList({
        pageNum: this.pageNum,
        appType: this.appType
      }).then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          this.bannerList = res.data.data
        }
      })
    },
    handleCurrentChange (val) { // 分页
      this.pageNum = val
      this.getBannerData()
    },
    handleSelectApp (item) { // 所属应用筛选
      console.log(item)
      this.appType = item
      this.getBannerData()
    },
    handleBannerDisbaled (id) { // 禁用及解禁banner
      disableBanner({ id }).then(res => {
        if (res.data.code === 200) {
          this.getBannerData()
        }
      })
    },

    handleUpdateClick (id) { // 修改banner
      this.$router.push({ path: 'banner/addBanner', query: { item: id } })
    },
    handleDeleteClick (id) { // 删除
      deleteBanner({ id: id }).then(res => {
        if (res.data.code === 200) {
          for (var i = 0; i < this.bannerList.result.length; i++) { // 从当前列别表中删除该数据
            if (this.bannerList.result[i].id === id) {
              this.bannerList.result.splice(i, 1)
              this.bannerList.total -= 1
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.banner-container
  padding 20px
  height 100%
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    background #fff
    .title_img
      margin 0 8px 0 14px
  .bannerlist_search
    width 100%
    background #fff
    position relative
    .el-form-item
      margin-bottom 5px
      margin-left 15px
    .search_btn
      searchBtn()
      margin-left 22px
    .btn_box
      width 80px
      float right
      position absolute
      top 0
      right 0
      .add_btn
        addBtn()
    .el-input
      width 210px
  .banner_table
    height calc(100% - 170px)
  .el-table
    background #f7f9fb
    .cell
      size12()
      .el-button
        padding 6px 14px
        width 28px
        cursor pointer
        height 28px
        margin 0 8px
        &.update
          update()
        &.unblocked
          unblocked()
        &.delete
          delete()
    .imgUrl
      width 80px
      height 46px
      margin 0 auto
      img
        width 80px
        height 46px
  .el-table th
    background #e7f0f8
    .cell
      height 25px
      line-height 25px
.el-popover
  max-width 166px
  background #e6f3fe
  border 1px solid #cfd5dc
  border-radius 1px
  size12()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
  .el-table td, .el-table th
    vertical-align center
</style>
